// Copyright (c) 2015, creqit Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (creqit.require) {
	creqit.require("file_uploader.bundle.js");
} else {
	creqit.ready(function () {
		creqit.require("file_uploader.bundle.js");
	});
}
